export default {
  title: 'Mobile App',
  fields: {
    name: 'App Name',
  },
  buttons: {
    save: 'Save',
  },
};
